export const firebaseConfig = {
	apiKey: "AIzaSyCa93Iy8uAkyjltyfhI7wL6VpHYqLJBXag",
	authDomain: "marito-trim.firebaseapp.com",
	databaseURL: "https://marito-trim.firebaseio.com",
	projectId: "marito-trim",
	storageBucket: "marito-trim.appspot.com",
	messagingSenderId: "939608873191",
	appId: "1:939608873191:web:f3ee3cd0dc22008ad52a42"
  };